import close from '../../assets/icons/close.svg';
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';
import arrowclockwise from '../../assets/icons/arrow-clockwise.svg';
import { getData, Postdata } from '../../API/GlobalApi';
const FilterTransactionModal = ({
    isOpen,
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    statusFilter,
    setStatusFilter,
    remitterName,
    setRemitterName,
    instrumentType,
    setInstrumentType,
    transactionType,
    handleSearch,
    onCancel,
    setActiveTab, setIsInitialLoad,
    setIsInitialLoadFeeReceive, transactionsReceivedBy,
    transactionsReceivedFrom, receiveFilters,
    setReceiveFilters, remittancesDepositedBy,
    remittancesDepositedIn, isLoading,
    activeTab, getTransactions, getFeeReceivedData, instrumentTypeFeeReceive, setInstrumentTypeFeeReceive, setFilterQueryStringFeeReceive, setFilterQueryString, getToday, setFromDateFeeReceive, setToDateFeeReceive
}) => {

    const isReceiveSelected = receiveFilters.receivedFrom || receiveFilters.receivedBy;
    const isDepositSelected = receiveFilters.depositedBy || receiveFilters.depositedIn;

    const statusOptions = [
        { value: "Received", label: "Received" },
        { value: "Transferred", label: "Transferred" },
        { value: "Deposited", label: "Deposited" },
        { value: "Reject", label: "Reject" },
        { value: "Re-Present", label: "Re-Present" },
        { value: "Success", label: "Success" },

    ];

    const instrumentOptions = [
        { value: "Cash", label: "Cash" },
        { value: "Cheque", label: "Cheque" },
        { value: "Demand Draft", label: "Demand Draft" },
        { value: "NEFT", label: "NEFT" },
        { value: "RTGS", label: "RTGS" },
        { value: "IMPS", label: "IMPS" },
        { value: "UPI", label: "UPI" },
        { value: "POS", label: "UPIQR" },
        { value: "Card", label: "Card" },
        { value: "EMI", label: "EMI" },
        { value: "Wallet", label: "Wallet" },
        { value: "Cheque in Bank", label: "Cheque in Bank" },
        { value: "UPI in Bank", label: "UPI in Bank" },
        { value: "Cash in Bank", label: "Cash in Bank" },
        { value: "Credit Card", label: "Credit Card" },
        { value: "Debit Card", label: "Debit Card" },
        { value: "Demand Draft in Bank", label: "Demand Draft in Bank" },
    ];




    if (!isOpen) return null;

    // Tabs depend on transaction type
    const tabs =
        transactionType === "Remitance"
            ? [
                { key: "date", label: "Remitance Date" },
                { key: "status", label: "Remitance Status" },
                { key: "receiveGroup", label: "Receive" },
                { key: "depositGroup", label: "Deposit" },
                { key: "instrument", label: "Instrument Type" },

            ]
            : [
                { key: "date", label: "Receiving Date" },
                { key: "instrument", label: "Mode of Payment" },
                { key: "receivedBy", label: "Received By" },
                { key: "receivedFrom", label: "Received From" },
            ];

    return createPortal(
        <div
            className="modal-overlay"
            style={{
                zIndex: 9999999,
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <div
                className="modal-content"
                style={{
                    position: 'relative',
                    width: '60vw',
                    backgroundColor: 'white',
                    zIndex: 10000000,
                    borderRadius: "8px",
                    padding: "20px",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                {/* Header */}
                <div className="modal-header-content d-flex justify-content-between align-items-center mb-3">
                    <h4 className="text-primary">Advance Filter</h4>
                    <button className="close-btn" onClick={onCancel}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Body */}
                <div className="row flex-grow-1">
                    {/* Tabs */}
                    <div className="col-md-3 border-end">
                        <div className="d-flex flex-column">
                            {tabs.map(tab => (
                                <button
                                    key={tab.key}
                                    onClick={() => setActiveTab(tab.key)}
                                    disabled={
                                        transactionType === "Remitance" &&
                                        ((tab.key === "receiveGroup" && isDepositSelected) ||
                                            (tab.key === "depositGroup" && isReceiveSelected))
                                    } // 🔒 Disable conflicting tab
                                    title={
                                        transactionType === "Remitance" &&
                                        ((tab.key === "receiveGroup" && isDepositSelected)
                                            ? "Clear Deposit filters to enable Receive"
                                            : (tab.key === "depositGroup" && isReceiveSelected)
                                                ? "Clear Receive filters to enable Deposit"
                                                : "")
                                    }
                                    style={{
                                        padding: "8px 10px",
                                        border: "none",
                                        background: activeTab === tab.key ? "rgb(242, 237, 255)" : "transparent",
                                        color: activeTab === tab.key ? "rgb(127, 86, 218)" : "#444",
                                        borderRadius: "5px",
                                        cursor: (transactionType === "Remitance" &&
                                            ((tab.key === "receiveGroup" && isDepositSelected) ||
                                                (tab.key === "depositGroup" && isReceiveSelected)))
                                            ? "not-allowed"
                                            : "pointer",
                                        opacity:
                                            (transactionType === "Remitance" &&
                                                ((tab.key === "receiveGroup" && isDepositSelected) ||
                                                    (tab.key === "depositGroup" && isReceiveSelected)))
                                                ? 0.6
                                                : 1,
                                        marginBottom: "5px",
                                        fontSize: "16px",
                                        textAlign: "left",
                                        fontWeight: activeTab === tab.key ? "600" : "500",
                                    }}
                                >
                                    {tab.label}
                                </button>
                            ))}

                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="col-md-9">
                        {/* DATE TAB */}
                        {activeTab === "date" && (
                            <div className='row d-flex gap-2 justify-content-start'>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>From</label>
                                    <input
                                        type="date"
                                        className="form-control custom-date-input"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>To</label>
                                    <input
                                        type="date"
                                        className="form-control custom-date-input"
                                        min={fromDate}
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        )}

                        {/* STATUS TAB (Remittance only) */}
                        {transactionType === "Remitance" && activeTab === "status" && (
                            <div className="row">
                                <div className="col-md-8 mb-3">
                                    <Select
                                        options={statusOptions}
                                        value={statusFilter}
                                        onChange={(selected) => setStatusFilter(selected || [])}
                                        isMulti
                                        placeholder="Select Status"
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 })
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        )}

                        {/* REMITTER NAME TAB (Remittance only) */}
                        {transactionType === "Remitance" && activeTab === "remitter" && (
                            <div className="row">
                                <div className="col-md-8 mb-3">
                                    <label className="form-labell" style={{ fontSize: '14px' }}>
                                        Remitter's Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={remitterName}
                                        onChange={(e) => setRemitterName(e.target.value)}
                                        placeholder="Enter Remitter's Name"
                                    />
                                </div>
                            </div>
                        )}


                        {/* INSTRUMENT / MODE OF PAYMENT TAB */}
                        {activeTab === "instrument" && (
                            <div className="row">
                                <div className="col-md-8 mb-3">
                                    <Select
                                        options={instrumentOptions}
                                        value={transactionType === "Remitance" ? instrumentType : instrumentTypeFeeReceive}
                                        onChange={(selected) => {
                                            if (transactionType === "Remitance") setInstrumentType(selected || []);
                                            else setInstrumentTypeFeeReceive(selected || []);
                                        }}
                                        isMulti
                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 })
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder={`Select ${transactionType === "Remitance" ? "Instrument" : "Mode"}`}
                                    />

                                </div>
                            </div>
                        )}


                        {/* RECEIVED FROM TAB */}
                        {activeTab === "receivedFrom" && (
                            <div className="row">
                                <div className="col-md-8 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>
                                        Received From
                                    </label>
                                    <Select
                                        options={
                                            transactionsReceivedFrom?.map(item => ({
                                                value: item.id,
                                                label: item.name
                                            })) || []
                                        }
                                        value={receiveFilters.receivedFrom}
                                        onChange={selected =>
                                            setReceiveFilters(prev => ({ ...prev, receivedFrom: selected }))
                                        }
                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder="Select Received From"
                                    />
                                </div>
                            </div>
                        )}

                        {/* RECEIVED BY TAB */}
                        {activeTab === "receivedBy" && (
                            <div className="row">
                                <div className="col-md-8 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>
                                        Received By
                                    </label>
                                    <Select
                                        options={
                                            transactionsReceivedBy?.map(item => ({
                                                value: item.id,
                                                label: item.name
                                            })) || []
                                        }
                                        value={receiveFilters.receivedBy}
                                        onChange={selected =>
                                            setReceiveFilters(prev => ({ ...prev, receivedBy: selected }))
                                        }
                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder="Select Received By"
                                    />
                                </div>
                            </div>
                        )}


                        {transactionType === "Remitance" && activeTab === "receiveGroup" && (
                            <div className="row">


                                <div className="col-md-8 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>Received From</label>
                                    <Select
                                        options={
                                            transactionsReceivedFrom?.map(item => ({
                                                value: item.id,
                                                label: item.name,
                                            })) || []
                                        }
                                        value={receiveFilters.receivedFrom}
                                        onChange={selected => {
                                            setReceiveFilters(prev => ({
                                                ...prev,
                                                receivedFrom: selected,
                                                depositedBy: null,
                                                depositedIn: null,
                                            }));
                                        }}

                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder="Select Received From"
                                    />
                                </div>

                                <div className="col-md-8 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>Received By</label>
                                    <Select
                                        options={
                                            transactionsReceivedBy?.map(item => ({
                                                value: item.id,
                                                label: item.name,
                                            })) || []
                                        }
                                        value={receiveFilters.receivedBy}
                                        onChange={selected => {
                                            setReceiveFilters(prev => ({
                                                ...prev,
                                                receivedBy: selected,
                                                depositedBy: null,
                                                depositedIn: null,
                                            }));
                                        }}

                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder="Select Received By"
                                    />
                                </div>
                            </div>
                        )}

                        {/* REMITTANCE — Deposited In */}
                        {transactionType === "Remitance" && activeTab === "depositGroup" && (
                            <div className="row">


                                <div className="col-md-8 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>Deposited By</label>
                                    <Select
                                        options={
                                            remittancesDepositedBy?.map(item => ({
                                                value: item.id,
                                                label: item.name,
                                            })) || []
                                        }
                                        value={receiveFilters.depositedBy}
                                        onChange={selected => {
                                            setReceiveFilters(prev => ({
                                                ...prev,
                                                depositedBy: selected,
                                                receivedFrom: null,
                                                receivedBy: null,
                                                // ❌ don't reset depositedIn
                                            }));
                                        }}

                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder="Select Deposited By"
                                    />
                                </div>

                                <div className="col-md-8 mb-3">
                                    <label className="form-label" style={{ fontSize: '14px' }}>Deposited In (Bank)</label>
                                    <Select
                                        options={
                                            remittancesDepositedIn?.map(item => ({
                                                value: item.id,
                                                label: `${item.bank_name} (${item.account_number})`,
                                            })) || []
                                        }
                                        value={receiveFilters.depositedIn}
                                        onChange={selected => {
                                            setReceiveFilters(prev => ({
                                                ...prev,
                                                depositedIn: selected,
                                                receivedFrom: null,
                                                receivedBy: null,
                                                // ❌ don't reset depositedBy
                                            }));
                                        }}

                                        isClearable
                                        styles={{
                                            ...reactSelectStyles,
                                            menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                        }}
                                        menuPortalTarget={document.body}
                                        placeholder="Select Bank Account"
                                    />
                                </div>
                            </div>
                        )}



                    </div>
                </div>

                {/* Footer */}
                {/* Footer */}
                <div
                    className="modal-footer"
                    style={{
                        marginTop: "auto",
                        display: "flex",
                        justifyContent: "space-between", // put buttons left/right
                        alignItems: "center",
                        borderTop: "1px solid #eee",
                        paddingTop: "15px",
                    }}
                >

                    <button className='btn' onClick={() => {

                        const today = getToday();
                        setStatusFilter([]);
                        setRemitterName("");
                        setInstrumentType([]);
                        setInstrumentTypeFeeReceive([]);
                        setIsInitialLoad(true);
                        setIsInitialLoadFeeReceive(true);
                        // ✅ Reset receiveFilters (all dropdowns)
                        setReceiveFilters({
                            receivedBy: null,
                            receivedFrom: null,
                            depositedBy: null,
                            depositedIn: null,
                        });

                        setFromDate(today);
                        setToDate(today);
                        setFromDateFeeReceive(today);
                        setToDateFeeReceive(today);
                        // const defaultFiltersFee = `start_date=${fromDateFeeReceive}&end_date=${toDateFeeReceive}`;
                        const defaultFiltersRemit = `start_date=${today}&end_date=${today}`;

                        // Call APIs with default filters
                        getFeeReceivedData(0, defaultFiltersRemit);
                        getTransactions(0, defaultFiltersRemit);

                        // Clear filter states
                        setFilterQueryStringFeeReceive("");
                        setFilterQueryString("");

                        onCancel();
                    }} style={{ color: 'red', cursor: 'pointer' }}>
                        Reset Filters <img src={arrowclockwise} alt="reset" />
                    </button>


                    {/* ✅ Search Button */}
                    <button
                        className="text-white flex items-center justify-center"
                        style={{
                            padding: "12px 25px",
                            background: "#7F56DA",
                            border: "none",
                            borderRadius: "6px",
                            minWidth: "120px",
                        }}
                        onClick={handleSearch}
                        disabled={isLoading} // ✅ disable button while loading
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" />

                            </>
                        ) : (
                            <>

                                Search
                            </>
                        )}
                    </button>


                </div>

            </div>
        </div>,
        document.body
    );
};

export default FilterTransactionModal;
